@if (!isLoading) {
  <div
    class="container flex-row justify-start align-center"
    (click)="onDeliverySectionClick()"
    [class.readonly]="isReadOnly">
    @if (showIcon) {
      <mat-icon class="delivery-icon"
        svgIcon="clock"
      [color]="isReadOnly ? 'accent' : iconColor"></mat-icon>
    }
    @if (deliveryDate) {
      <span class="delivery-title"
      >{{ 'COMMON.DATE_AT_TIME' | transloco: { date: deliveryDateLabel, time: deliveryHourLabel } }}</span>
    }
    @if (!deliveryDate && !isReadOnly) {
      <span>{{ promptMessageWhenEmpty | transloco }}</span>
    }
    @if (!isReadOnly) {
      <mat-icon class="delivery-icon"
      >keyboard_arrow_down</mat-icon>
    }
  </div>
} @else {
  <app-mini-content-loader></app-mini-content-loader>
}


<!-- TODO add error ui -->
<!--
<div *ngIf="control?.touched && (errors$ | async) as errors"
  @errorInOutAnimation
  class="cart-payment-errors">
  <mat-error *ngIf="errors['required']">{{ errors['required'] }}</mat-error>
</div> -->
